var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enroll-info-student"},[_c('PlatDataGridGrade',{attrs:{"grid-id":"PeEnrollStudentInfo","show-label":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }